import React from "react";
import ReactDOM from "react-dom/client";
import App from "./components/App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import UserService from "./services/UserService";

const renderApp = () => {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  /* root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ); */
  root.render(<App />);
};

UserService.initKeycloak(renderApp);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
